import { SYSTranslation } from "../../ovlsyscomponents/systranslation01/screens/allactions"
import { SYSAudit } from "../../ovlsyscomponents/sysaudit01/screens/allactions"
import { SYSEPT } from "../../ovlsyscomponents/sysept01/screens/allactions"
import { SYSLandingPage01 } from "../../ovlsyscomponents/syslandingpage01/screens/allactions"
import { SYSTableDetailView } from "../../ovlsyscomponents/systabledetailview01/screens/allactions"

export let screens = {
  SYSTranslation,
  SYSAudit,
  SYSLandingPage01,
  SYSEPT,
  SYSTableDetailView,
}
